import { css } from 'lit'

export default css`
    .container {
        display: flex;
        line-height: 1.375;
    }
    .icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: var(--zaptic-timeline-event-iconSize, 2em);
        height: var(--zaptic-timeline-event-iconSize, 2em);
        border-radius: 50%;
        background-color: var(--zaptic-timeline-event-iconBgColor, var(--grey6));
        color: white;
        margin-right: 0.65em;
    }
    .details {
        display: flex;
        flex-direction: column;
        font-size: 1em;
        flex: 1;
    }
    .icon > svg {
        font-size: 1em;
    }
    .date {
        font-size: 0.875em;
        font-weight: var(--font-weight-regular);
        color: var(--grey3);
    }
`
